/** Returns today's date in ISO format YYYY-MM-DD (MySQL-friendly, unambiguous). */
export function getTodayYYYYMMDD(): string {
	const d = new Date();
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
}
